import Reservations from './reservations.js';
import Spinner from './spinner.js';
import { formatDateForPrinting, EventHandler } from '../../base/utils.js';

class UpcomingReservationPreview {
  constructor() {
    this.$component = $('.upcoming-reservation-preview');

    Spinner.appendTo(this.$component);
    $(document).one('getUpcomingResData:success', () => {
      this.checkForUpcoming(Reservations.userResData);
      Spinner.remove(this.$component);
      EventHandler.triggerEvent('upcoming-reservation', {
        upcomingReservation: 'yes'
      });
    });
    $(document).one('getResData:none', () => {
      this.noReservationsFound();
      Spinner.remove(this.$component);
      EventHandler.triggerEvent('upcoming-reservation', {
        upcomingReservation: 'no'
      });
    });
    $(document).one('getResData:always', () => {
      Spinner.remove(this.$component);
    });
  }
  checkForUpcoming(userData) {
    if (userData.reservations) {
      if (userData.reservations.current) {
        this.populateReservation(userData.reservations.current, userData.property);
        $('.upcoming-reservation-preview .current-res-headline').removeClass('hidden');
        $('.upcoming-reservation-preview .upcoming-res-content').removeClass('hidden');
      } else if (userData.reservations.future) {
        this.populateReservation(userData.reservations.future, userData.property);
        $('.upcoming-reservation-preview .upcoming-res-headline').removeClass('hidden');
        $('.upcoming-reservation-preview .upcoming-res-content').removeClass('hidden');
      } else {
        this.noReservationsFound();
      }
    } else {
      this.noReservationsFound();
    }
  }
  noReservationsFound() {
    if ($('.member-benefits-container').length > 0) {
      $('.member-benefits-container').removeClass('hidden');
    }

    $('.mobile-nav-reservation-preview').addClass('hidden');
    $('.mobile-nav-no-reservation-promo-tout').removeClass('hidden');
  }
  populateReservation(resData, propData) {
    resData = resData[0] || resData;
    let propertyId = resData.rooms.brandId + resData.rooms.propertyCode;
    propData = propData[propertyId];
    let brandId = resData.rooms.brandId,
      confirmationNumber = resData.confirmationNumber,
      firstName = resData.rooms.firstName,
      lastName = resData.rooms.lastName,
      checkInDate = resData.rooms.checkInDate,
      checkOutDate = resData.rooms.checkOutDate,
      checkInFormatted = formatDateForPrinting(checkInDate, 'weekdayCompactAlt'),
      checkOutFormatted = formatDateForPrinting(checkOutDate, 'weekdayCompactAlt'),
      propertyName = propData.propertyName,
      propertyPhone = propData.phone || '',
      propertyAddress = propData.propertyAddress,
      propertyCity = propData.propertyCity,
      propertyState = propData.propertyState,
      propertyPostalCode = propData.propertyPostalCode,
      fullPropertyAddress = [propertyAddress, propertyCity, propertyState, propertyPostalCode].join(', '),
      propertyMapUrl = null;

    if (propData.latitude && propData.longitude) {
      propertyMapUrl = 'https://maps.apple.com/maps?ll=' + propData.latitude + ',' + propData.longitude + '&q=' + encodeURIComponent(fullPropertyAddress);
    }
    let $upcomingPreview = $('.upcoming-reservation-preview .upcoming-res-content');

    $upcomingPreview.find('.brand-icon-logo .logo').addClass('logo-' + brandId);
    $upcomingPreview.find('.property-name').text(propertyName);
    $upcomingPreview.find('.check-in-date').text(checkInFormatted);
    $upcomingPreview.find('.check-out-date').text(checkOutFormatted);
    $upcomingPreview.find('.property-phone').text(propertyPhone);
    $upcomingPreview.find('.property-phone.visible-xs-inline-block').attr('href', 'tel:' + propertyPhone);
    $upcomingPreview.find('.property-address').attr('href', propertyMapUrl);
    $upcomingPreview.find('.property-address .address').text(propertyAddress);
    $upcomingPreview.find('.property-address .city').text(propertyCity);
    $upcomingPreview.find('.property-address .state').text(propertyState);
    $upcomingPreview.find('.property-address .postal-code').text(propertyPostalCode);
    $upcomingPreview.find('.view-res-confirmation-link').attr('data-first', firstName);
    $upcomingPreview.find('.view-res-confirmation-link').attr('data-last', lastName);
    $upcomingPreview.find('.view-res-confirmation-link').attr('data-conf', confirmationNumber);
  }
}

export default new UpcomingReservationPreview();
